import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { LightningId } from 'owa-lightning-v2';
import {
    onTargetedAdV3Dismiss,
    targetedAdV3Dismissed,
} from 'mini-gdprv3-ads-opt-in/lib/utils/targetedAdUtils';
import {
    onTargetedAdLgpdDismiss,
    targetedAdLgpdDismissed,
} from 'mini-lgpd-opt-in/lib/utils/targetedAdUtils';
import {
    onTargetedEUAdsDismiss,
    targetedEUAdsDismissed,
} from 'owa-euemailads-optin/lib/utils/targetedAdUtils';
import {
    isLgpdAdMarket,
    isGdprAdMarket,
    isEUEmailAdsPolicyMarket,
} from 'mini-mail-nativead-userchecker';
import {
    lazyInitializeCampaignFramework,
    lazyIsLightningIdPresent,
    lazyUpdateCampaignSessionCount,
} from 'mini-campaign-bootstrap';

/**
 * Function which lazily triggers the unseen lightning api call, and updates the campaign session count for mail
 * immediately or after GDPR ad dialog is dismissed based on whether the GDPR lightning id is present or not.
 */
export function triggerLazyInitializeCampaignFrameworkForMail() {
    lazyInitializeCampaignFramework.importAndExecute().then(async () => {
        if (isLgpdAdMarket()) {
            const lgpdlightningid = '87';
            const isLgpdLightningPresent = await lazyIsLightningIdPresent.importAndExecute(
                lgpdlightningid
            );
            if (!isLgpdLightningPresent) {
                targetedAdLgpdDismissed();
            } else {
                onTargetedAdLgpdDismiss();
            }
        }

        if (isEUEmailAdsPolicyMarket()) {
            const euEmailAdsLightningid = '110';
            const iseuEmailAdsLightningPresent = await lazyIsLightningIdPresent.importAndExecute(
                euEmailAdsLightningid
            );
            if (!iseuEmailAdsLightningPresent) {
                targetedEUAdsDismissed();
            } else {
                onTargetedEUAdsDismiss();
            }
        }

        if (isGdprAdMarket()) {
            const isgdprLightningPresent = await lazyIsLightningIdPresent.importAndExecute(
                LightningId.GdprAdsV3ClearNull
            );
            if (!isgdprLightningPresent) {
                targetedAdV3Dismissed();
            } else {
                onTargetedAdV3Dismiss();
            }
        }

        lazyUpdateCampaignSessionCount.importAndExecute(CampaignId.MiniMailSharedCampaign);
    });
}
